import { getAgencyProximity, getAgencyRating } from '@shared-utils/helpers/cardDisplay';
import { EventBus } from '@shared-utils/helpers/eventBus';
import { AV_ITEMS_INTERMEDIARY } from '@shared-utils/types/analytics.types';
import { AV_INITIATIVE, Context } from '@shared-utils/types/common.types';
/**
 * Trace analytics events
 */
export const analyticsDebug = (event) => {
    if (process.env.ENVIRONMENT === 'dev') {
        global.console.log('onAnalytics', event);
    }
};
/**
 * Send analytics event type with debug handling for all events types
 */
export const sendAnalyticsEvent = (event, logger, parentId) => {
    const commonTags = {
        av_category: '%av_category%',
        av_initiative: AV_INITIATIVE,
    };
    const eventType = {
        ...event,
        ...commonTags,
    };
    analyticsDebug(eventType);
    EventBus.emit('onAnalytics', eventType, logger, parentId);
};
/**
 * Normalize the city name for GA4 av_items.city by removing special characters, replacing `-` and spaces with `_` and converting to lower case (for instance : "Saint-Leu-la-Forêt" becomes "saint_leu_la_foret")
 * @param city City name
 * @return Normalized city name
 */
export const normalizedGa4City = (city) => {
    return city
        ?.replace(/[ '-]/g, '_')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
};
export const stringifyRating = (brand, reviews) => {
    if (!reviews) {
        return undefined;
    }
    return getAgencyRating(reviews.avgRating, brand).toString();
};
/**
 * Generate av_items list object for all analytics events for Price Pages usecase
 */
export const generateAVItemPricePages = (agency, av_list_name, index) => {
    const { distance, id, propertiesForSale, reviews, address } = agency;
    return {
        agency_proximity: distance ? getAgencyProximity(distance) : undefined,
        city: normalizedGa4City(address.city),
        id: id,
        index: index,
        list_name: av_list_name,
        name: AV_ITEMS_INTERMEDIARY,
        properties_for_sale: propertiesForSale.toString(),
        rating: reviews ? reviews.avgRating.toString() : undefined,
        zip_code: address.zipCode,
    };
};
/**
 * Build tracking medium for IPP page
 * @param context mandatory info required to build the medium
 * @param link mandatory info required to build the medium - indicates from where the user came from
 * @param additionalData optional info required to build the medium - used to condition the medium
 * @return medium to add to the url
 */
export const buildIPPMedium = (context, link, additionalData) => {
    let additionalDataTrackingTag;
    let medium = '';
    switch (context) {
        case Context.ESTIMATION_FUNNEL:
            if (typeof additionalData !== 'boolean') {
                additionalDataTrackingTag = 'funnel_type';
            }
            else {
                additionalDataTrackingTag = additionalData ? 'update' : 'new';
            }
            medium = `?m=estimate_confirmation_${additionalDataTrackingTag}_${link}_intermediary_profile_page`;
            break;
        case Context.PRICE_MAP:
            medium = `?ln=agency_card&m=price_map_${link}_intermediary_profile_page`;
            break;
    }
    return medium;
};
